import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {DeclineSpecialRequestRequest} from '../special-request/decline-special-request-request.model';
import { HttpClient } from '@angular/common/http';
import {AuthService} from '../auth/auth.service';
import {environment} from '../../environments/environment';

{
}

@Injectable({
  providedIn: 'root'
})
export class WarrantyService {

  constructor(private httpClient: HttpClient, private authService: AuthService) {
  }

  specialRequestExistsForVin(vin: string): Observable<boolean> {
    return this.httpClient.get<boolean>(`${environment.baseUrl}/specialRequestExistsForVin/${vin}`, {headers: this.authService.getHeaders()});
  }

  declineSpecialRequest(request: DeclineSpecialRequestRequest): Observable<number> {
    return this.httpClient.post<number>(`${environment.baseUrl}/declineSpecialRequest`, request, {headers: this.authService.getHeaders()});
  }
}
